import Link from "next/link";
import { useRouter } from "next/router";

const LINKS = [
  // Core pages
  { href: "/about", label: "About Afivio", group: "Company" },
  { href: "/pricing", label: "Pricing", group: "Company" },
  { href: "/how-it-works", label: "How it works", group: "Company" },
  { href: "/faq", label: "FAQ", group: "Company" },
  { href: "/contact", label: "Contact", group: "Company" },
  { href: "/blog", label: "Blog", group: "Company" },

  // Marketing pages
  { href: "/affiliate-marketing", label: "Affiliate marketing", group: "Affiliate" },
  { href: "/detailed-overview", label: "Detailed overview", group: "Overview" },
  { href: "/program-promotion", label: "Program promotion", group: "Overview" },
  { href: "/influencer-marketing", label: "Influencer marketing", group: "Influencer" },
  { href: "/partners", label: "Partners", group: "Partners" },
  { href: "/referral-marketing", label: "Referral marketing", group: "Referral" },

  // Integration pages
  { href: "/shopify-integration", label: "Shopify integration", group: "Integrations" },
  { href: "/shopify-guides", label: "Shopify guides & free tools", group: "Integrations", locale: "en" },
  { href: "/wordpress-woocommerce-integration", label: "WordPress integration", group: "Integrations" },
  { href: "/stripe-integration", label: "Stripe integration", group: "Integrations" },
  { href: "/custom-api-integration", label: "Custom API integration", group: "Integrations" },
  { href: "/manual-integration", label: "Manual integration", group: "Integrations" },
  { href: "/horoshop-integration", label: "Horoshop integration", group: "Integrations" },

  // Additional SEO pages
  { href: "/affiliate-marketing-software", label: "Affiliate marketing software", group: "Affiliate" },
  { href: "/affiliate-tracking-software", label: "Affiliate tracking software", group: "Affiliate" },
  { href: "/influencer-marketing-platform", label: "Influencer marketing platform", group: "Influencer" },
  { href: "/partner-management-software", label: "Partner management software (PRM)", group: "Partners" },
  { href: "/referral-program-software", label: "Referral program software", group: "Referral" },
];

function normalizePath(p) {
  if (!p) return "/";
  const clean = p.split("?")[0].split("#")[0];
  if (clean.length > 1 && clean.endsWith("/")) return clean.slice(0, -1);
  return clean;
}

export function SeoInternalLinks({
                                   className = "",
                                   heading = "Explore related pages",
                                 }) {
  const router = useRouter();
  const current = normalizePath(router.asPath);

  const currentItem = LINKS.find((link) => link.href === current);
  const currentGroup = currentItem?.group;
  const isAlternative = current.endsWith("-alternative");
  const preferredGroups = isAlternative
    ? ["Affiliate", "Partners", "Company"]
    : currentGroup === "Integrations"
      ? ["Integrations", "Affiliate", "Company"]
      : [currentGroup, "Company", "Integrations"];
  const ordered = preferredGroups
    .flatMap((group) => LINKS.filter((link) => link.href !== current && link.group === group))
    .filter((link, index, links) => links.findIndex((item) => item.href === link.href) === index)
    .slice(0, 4);

  return (
      <aside
          className={[
            "mt-16 border-t border-gray-100 pt-6",
            "text-[11px] leading-5 text-gray-400",
            className,
          ].join(" ")}
          aria-label={heading}
      >
        <p className="mb-3 text-center text-xs font-semibold uppercase tracking-wide text-gray-500">{heading}</p>

        <nav className="max-w-7xl mx-auto px-6">
          <div className="flex flex-wrap gap-x-3 gap-y-1 justify-center opacity-80">
            {ordered.map((l) => (
                <Link
                    key={l.href}
                    href={l.href}
                    locale={l.locale}
                    className="hover:opacity-100 hover:text-gray-500 underline-offset-2 hover:underline transition-opacity"
                >
                  {l.label}
                </Link>
            ))}
          </div>
        </nav>
      </aside>
  );
}
